import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-check\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 243.2l-473.6 473.6L128 422.4c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l313.6 313.6c12.8 12.8 32 12.8 44.8 0l499.2-499.2c12.8-12.8 12.8-32 0-44.8-12.8-6.4-32-6.4-44.8 6.4z\" p-id=\"2037\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol